var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1881 6.09286C12.1881 7.43739 11.7516 8.67939 11.0162 9.68706L14.7253 13.3984C15.0916 13.7646 15.0916 14.3592 14.7253 14.7254C14.3591 15.0915 13.7643 15.0915 13.3981 14.7254L9.68895 11.014C8.68109 11.7522 7.43884 12.1857 6.09405 12.1857C2.72767 12.1857 0 9.45858 0 6.09286C0 2.72714 2.72767 0 6.09405 0C9.46042 0 12.1881 2.72714 12.1881 6.09286ZM6.09405 10.311C6.64809 10.311 7.1967 10.2019 7.70857 9.9899C8.22044 9.77792 8.68553 9.46722 9.0773 9.07553C9.46907 8.68384 9.77983 8.21883 9.99185 7.70707C10.2039 7.1953 10.313 6.64679 10.313 6.09286C10.313 5.53892 10.2039 4.99042 9.99185 4.47865C9.77983 3.96688 9.46907 3.50188 9.0773 3.11019C8.68553 2.7185 8.22044 2.40779 7.70857 2.19581C7.1967 1.98383 6.64809 1.87473 6.09405 1.87473C5.54001 1.87473 4.99139 1.98383 4.47952 2.19581C3.96766 2.40779 3.50256 2.7185 3.1108 3.11019C2.71903 3.50188 2.40826 3.96688 2.19624 4.47865C1.98422 4.99042 1.87509 5.53892 1.87509 6.09286C1.87509 6.64679 1.98422 7.1953 2.19624 7.70707C2.40826 8.21883 2.71903 8.68384 3.1108 9.07553C3.50256 9.46722 3.96766 9.77792 4.47952 9.9899C4.99139 10.2019 5.54001 10.311 6.09405 10.311Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/loop.4f6e8a1c9bc795786d838842151f5931.svg";
export { ForwardRef as ReactComponent };